import { appointmentBaseModel } from './crud';

export * from './types';

export const useAppointmentById = appointmentBaseModel.fetchById();
export const useAppointmentByIds = appointmentBaseModel.fetchByIds();
export const useAppointmentMany = appointmentBaseModel.fetchMany();
export const useAppointmentCount = appointmentBaseModel.count();
export const useAppointmentManyInfiniteQuery =
  appointmentBaseModel.fetchPaginated();
export const useAppointmentUpdateOne = appointmentBaseModel.edit();
export const useAppointmentCreateOne = appointmentBaseModel.create();
export const useAppointmentRemoveOne = appointmentBaseModel.delete();
export const useAppointmentRemoveByIds = appointmentBaseModel.deleteByIds();

export const useAppointmentByIdV2 = appointmentBaseModel.fetchByIdV2();
export const useAppointmentByIdsV2 = appointmentBaseModel.fetchByIdsV2();
export const useAppointmentManyV2 = appointmentBaseModel.fetchManyV2();
export const useAppointmentCountV2 = appointmentBaseModel.countV2();
export const useAppointmentManyInfiniteQueryV2 =
  appointmentBaseModel.fetchPaginatedV2();
export const useAppointmentUpdateOneV2 = appointmentBaseModel.editV2();
export const useAppointmentCreateOneV2 = appointmentBaseModel.createV2();
export const useAppointmentRemoveOneV2 = appointmentBaseModel.deleteV2();
export const useAppointmentRemoveByIdsV2 = appointmentBaseModel.deleteByIdsV2();

export const useAppointmentPagination = appointmentBaseModel.fetchPaginated();
export const useAppointmentPaginationV2 =
  appointmentBaseModel.fetchPaginatedV2();
